/**
 * Embedded by tsup at build time via the `pkg.version` field. We just hard-
 * code matching the package.json version here — the `prepublishOnly` step
 * keeps them in sync.
 */
export const CLI_VERSION = "0.0.9";
